"use client";

import { c as _c } from "react/compiler-runtime";
import { Check, Copy, FileCode2 } from "lucide-react";
import type { Dictionary } from "@/dictionaries/types";
import { useCopy } from "../data/useCopy";
import FitHex from "../FitHex";

/**
 * The contract as the collection's seal, set in the nameplate beside its
 * maker — where a collector looks for "which one is this". The address is
 * shown whole wherever the line has room and shortened from the middle only
 * where it does not (`FitHex`); the full one is on the copy button's name. The explorer is on
 * the action plaque with the other ways out.
 */
export default function ContractSeal(t0) {
  const $ = _c(17);
  const {
    address,
    t
  } = t0;
  const {
    copied,
    copy
  } = useCopy(address, t.contractCopied, 1600);
  const t1 = copied || undefined;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="vt-seal-mark" aria-hidden={true}><FileCode2 /></span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t.contract) {
    t3 = <span className="vt-seal-label">{t.contract}</span>;
    $[1] = t.contract;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `${t.copyContract}: ${address}`;
  let t5;
  if ($[3] !== address) {
    t5 = <FitHex value={address} className="vt-seal-hex" />;
    $[3] = address;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== copied) {
    t6 = copied ? <Check aria-hidden={true} /> : <Copy aria-hidden={true} />;
    $[5] = copied;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== address || $[8] !== copy || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <button type="button" className="vt-seal-addr v2-focus" onClick={copy} aria-label={t4} title={address}>{t5}{t6}</button>;
    $[7] = address;
    $[8] = copy;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t3 || $[15] !== t7) {
    t8 = <span className="vt-seal" data-copied={t1}>{t2}{t3}{t7}</span>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}